// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ProductList_wrap__HV1i7"};